export default __webpack_public_path__ + "static/media/page3Bg.bf29d77b.png";